import { ColumnTable, TextOutlinedInput } from '@octano/global-ui';
import { useMemo } from 'react';
import { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TariffFormatter } from '../../../../../utils/currency';

const prefix = 'tariffAndTuition.subsidies';

interface PeriodRow {
  id: number;
  name: string;
  code: string;
  startDate: string;
  endDate: string;
  defaultValue: string;
}

interface SubsidyFormValues {
  name: string;
  applyAutomatically: boolean;
  periodAmounts: { [key: number]: string };
}

interface UseSubsidyPeriodColumnsProps {
  control: Control<SubsidyFormValues>;
}

export function useSubsidyPeriodColumns({
  control,
}: UseSubsidyPeriodColumnsProps) {
  const { t } = useTranslation();

  const columns: ColumnTable<PeriodRow>[] = useMemo(
    () => [
      {
        columnName: 'name',
        headerText: t(`${prefix}.period`),
        thClassName: 'text-left',
        tdClassName: 'text-left',
      },
      {
        columnName: 'code',
        headerText: t(`${prefix}.periodCode`),
        thClassName: 'text-left',
        tdClassName: 'text-left',
      },
      {
        columnName: 'startDate',
        headerText: t(`${prefix}.startDate`),
        thClassName: 'text-center',
        tdClassName: 'text-center',
        cellFormat: ({ row }) =>
          new Date(row.startDate).toLocaleDateString('es-CL'),
      },
      {
        columnName: 'endDate',
        headerText: t(`${prefix}.endDate`),
        thClassName: 'text-center',
        tdClassName: 'text-center',
        cellFormat: ({ row }) =>
          new Date(row.endDate).toLocaleDateString('es-CL'),
      },
      {
        columnName: 'amount',
        headerText: t(`${prefix}.discountAmount`),
        thClassName: 'text-center',
        tdClassName: 'text-center',
        width: '120px',
        cellFormat: ({ row }) => (
          <div style={{ width: '80px' }}>
            <TextOutlinedInput
              name={`periodAmounts.${row.id}` as any}
              control={control}
              defaultValue={TariffFormatter(row.defaultValue)}
              placeholder="$0"
              textAlign="center"
              formatter={(value: string) => TariffFormatter(value)}
            />
          </div>
        ),
      },
    ],
    [t, control],
  );

  return columns;
}

export type { PeriodRow };
